module.exports = __webpack_public_path__ + "static/media/coverPlanning.099bc365.png";